import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const StrikesUpSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 11L11.995 6L17 11M7 17L11.995 12L17 17" stroke="currentColor" strokeLinecap="round"/>
    </svg>
)
const StrikesUpIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {StrikesUpSvg}
    </SvgIcon>
);
export default StrikesUpIcon
